/*========================================================================
* $Id: client-config.js 151646 2020-04-06 12:10:53Z sabri.nuzi $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["jquery"], function($) {
  var clientConfigOptions = {
    useLegacyMessageFrameChannel: 'mes:use-legacy-message-frame-channel',
    loginStatus: 'mes:loginstatus',
    logoutDisabled: 'mes:logoutdisabled',
    displayUsername: 'display:mes:user',
    username: 'mes:decrypted:user',
    ajaxRequestTimeout: 'mes:ajax-request-timeout',
    enhancedPDFPreview: 'mes:enable-content-preview',
    telemetryEnabled: 'app:telemetry:enabled',
    userCountry: 'mes:user-country'
  }

  var clientConfig = {
    getUseLegacyMessageFrameChannel: function () {
        var value = getMetaInformation(clientConfigOptions.useLegacyMessageFrameChannel);

        return getValueAsBoolean(value);
    },

    getUserCountry: function () {
      return getMetaInformation(clientConfigOptions.userCountry);
    },

    getLoginStatus: function () {
      return getMetaInformation(clientConfigOptions.loginStatus);
    },

    getLogoutDisabled: function () {
      var value = getMetaInformation(clientConfigOptions.getLogoutDisabled);

      return getValueAsBoolean(value);
    },

    // returns true | false as string
    getDisplayUsername: function () {
      return getMetaInformation(clientConfigOptions.displayUsername);
    },
    
    getUsername: function () {
      var username = getMetaInformation(clientConfigOptions.username);
      if (!username) {
        return "";
      }
      return username;
    },

    getUsernameWithoutAt: function () {
      var username = getMetaInformation(clientConfigOptions.username);
      if (!username) {
        return "";
      }
      if (username.indexOf("@") > 0) {
        var nameMatch = username.match(/^([^@]*)@/);
        username = nameMatch ? nameMatch[1] : '';
      }
      return username;
    },
       
    getAjaxRequestTimeoutInMs: function () {
      var value = getMetaInformation(clientConfigOptions.ajaxRequestTimeout);

      return parseInt(value) || null;
    },

    getTelemetryEnabled: function () {
      var value = getMetaInformation(clientConfigOptions.telemetryEnabled);

      return getValueAsBoolean(value);
    },

    getEnhancedPDFPreview: function () {
      var value = getMetaInformation(clientConfigOptions.enhancedPDFPreview);

      return getValueAsBoolean(value);
    }
  }

  function getMetaInformation(name) {
    return $('meta[name="' + name + '"]').attr("content");
  };

  /**
   * 
   * @param {*} stringValue 
   * @return true only if value is "true", otherwise returns false
   */
  function getValueAsBoolean(stringValue) {
    return /^true$/i.test(stringValue);
  }

  return clientConfig;
});
